var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[[_c('v-row',[_c('v-col',{attrs:{"cols":"4"}}),_c('v-col',{attrs:{"cols":"4"}},[_c('h1',{staticStyle:{"color":"red"}},[_vm._v(" Component Not Found ")])])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }